import { render, staticRenderFns } from "./personal-data.component.vue?vue&type=template&id=1adf6694&"
import script from "./personal-data.component.vue?vue&type=script&lang=ts&"
export * from "./personal-data.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "personal-data.component.vue"
export default component.exports